import { useTranslation } from "react-i18next";

export const status_options= [
    { value: 1, label: "active", color: '#03a9f4' },
    { value: 0, label: "passive", color:'#de8e8c' },
    { value: 3, label: "archived", color: 'black' },
  ];

export const status_selectbox = (data) => {
    const {t} = useTranslation();
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: data.color,
            marginRight: '8px',
          }}
        ></span>
        {t(data.label)}
      </div>
    );
  };

export const statusCellRender = (data: any) => {
    const val = typeof data.value === 'boolean' ? (data.value ? 1 : 0) : data.value;
    const status = status_options.find(s => s.value === val) || status_options[1];
    const text = val === 1 ? 'Aktif' : val === 0 ? 'Pasif' : 'Arşiv';
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: status.color,
            flexShrink: 0,
          }}
        />
        <span style={{ color: 'var(--base-text-color, #333)' }}>{text}</span>
      </div>
    );
  };

